import React from 'react'
import MainContentsWithSidebarInbox from 'components/templates/MainContentsWithSidebarInbox'
import ModalSelect from 'components/organisms/ModalSelect'
import LoadingView from 'components/atoms/LoadingView'

type PropTypes = {
  sidebarComponent: ?any,
  isShowContentsSp?: ?boolean,
  isModalActive?: ?boolean,
  isLoading?: ?boolean,
  onClickPositiveButton: Function,
  closeModal: Function,
}

export default function ReservationCancelPage(props: PropTypes) {
  return (
    <React.Fragment>
      <MainContentsWithSidebarInbox
        sidebarInbox={props.sidebarComponent}
        isShowContentsSp={props.isShowContentsSp}
      >
        {props.children}
      </MainContentsWithSidebarInbox>
      <ModalSelect
        title={i18n.t('page.dashboard.reservation.cancelModal.title')}
        textList={[i18n.t('page.dashboard.reservation.cancelModal.text')]}
        positiveButton={{
          text: i18n.t('page.dashboard.reservation.cancelModal.positive'),
          onClick: props.onClickPositiveButton,
        }}
        negativeButton={{
          text: i18n.t('page.shared.cancel'),
          onClick: props.closeModal,
        }}
        isActive={!!props.isModalActive}
        onClickClose={props.closeModal}
      />
      {props.isLoading && <LoadingView />}
    </React.Fragment>
  )
}



// WEBPACK FOOTER //
// ./src/components/pages/ReservationCancelPage/index.jsx